<div class="main_content px-3 position-relative">
  <div class="container-fluid py-3">
    <div class="title mb-4">
      <h2 class="w-100">Mass Messaging</h2>
    </div>

    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div class="white_box shadow p-3">
          <div class="row">
            <div class="col-lg-8 col-md-12 col-sm-12 col-xs-12">
              <div class="nm_contact">
                <h4>MESSAGE DETAILS</h4>
                <form [formGroup]="messageForm">
                  <div class="form-group position-relative">
                    <div class="input-group mt-3">
                      <input
                        type="text"
                        class="form-control"
                        formControlName="title"
                        placeholder="Title"
                      />
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <i class="fas fa-edit"> </i>
                        </span>
                      </div>
                    </div>
                    <ng-container
                      *ngIf="submitted && messageFormV.title.errors"
                    >
                      <p
                        class="error-message"
                        *ngIf="messageFormV.title.errors.required"
                      >
                        Title is required!
                      </p>
                    </ng-container>
                  </div>
                  <div class="form-group position-relative">
                    <div class="input-group mt-3">
                      <textarea
                        class="form-control"
                        rows="6"
                        formControlName="description"
                        placeholder="Description"
                      ></textarea>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <i class="fas fa-edit"> </i>
                        </span>
                      </div>
                    </div>

                    <ng-container
                      *ngIf="submitted && messageFormV.description.errors"
                    >
                      <p
                        class="error-message"
                        *ngIf="messageFormV.description.errors.required"
                      >
                        Description is required!
                      </p>
                    </ng-container>
                  </div>
                </form>
                <a class="com_btn" (click)="saveMassMessaging()">SAVE</a>
              </div>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12">
              <div class="mass_img">
                <img loading="lazy"
                  src="../../../assets/images/new/img_thumb.jpg"
                  *ngIf="profile_pic_url_selected != 1"
                />
                <img loading="lazy"
                  src="{{ profile_pic_url }}"
                  *ngIf="profile_pic_url_selected == 1"
                  class="profile_pic"
                />
              </div>
              <div class="profile_uplode mt-3 text-center">
                <button
                  type="button"
                  class="hover_btn"
                  (click)="fileInput.click()"
                >
                  Select image
                  <input
                    #fileInput
                    type="file"
                    #file
                    hidden
                    (change)="onImageSelected(file.files, $event)"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
